// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nf-0";